import React, { useState } from "react";
import { Card } from "../card";
import { ListTable } from "../Table/listTable/listTable";
import { studentsListTitle } from "../../Constants/tableTitles/ListTableTitle/studentsList.titles";
import { useStudentsLists } from "../../hooks/students/useStudentsLists.hooks";
import { transformStudentsListTableData } from "../../Services/transformer/transformStudentsListTableData";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../Constants/paths";
import { StudentNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";

export const StudentList = () => {
  const [pageToSearch, setPageToSearch] = useState(1);

  const navigate = useNavigate();
  const { isLoading: isStudentsListLoading, data: studentsList } =
    useStudentsLists({ page: pageToSearch });

  if (isStudentsListLoading) {
    return <></>;
  }
  return (
    <Card cardTitle="Students list">
      <ListTable
        titles={studentsListTitle}
        data={studentsList?.result || []}
        pagination={{
          onPageChange: (pageNo) => {
            setPageToSearch(pageNo);
          },
          totalPage: studentsList?.lastPage || 1,
        }}
        transformFn={transformStudentsListTableData}
        onRowClick={(data: any) => {
          navigate(
            `${Paths.StudentDetails}?section=${StudentNavigationHeader.STUDENT_INFO}&studentId=${data.id}`
          );
        }}
      />
      <></>
    </Card>
  );
};
